import Form from "./form_controller"
import EventEmitter from "../utils/EventEmitter"
import {removeErrorsOnFields} from "../utils/fields"

export default class extends Form {

    static targets = [
    ]

    initialize() {

    }

    plus(e){
        let $parent = e.currentTarget.parentNode
        let $input = $parent.querySelector(".input-option__input")
        let inputValue = $input.value
        inputValue++
        $input.value = inputValue
        EventEmitter.emit("change", {}, $input)
    }

    minus(e){
        let $parent = e.currentTarget.parentNode
        let $input = $parent.querySelector(".input-option__input")
        let inputValue = $input.value
        if (inputValue > 0) {
            inputValue--
           $input.value = inputValue
        }
        EventEmitter.emit("change", {}, $input)
    }

}